// frontend/src/store/navGuardStore.ts
import { create } from 'zustand';

interface NavGuardState {
  /** Non-null when navigation should prompt for confirmation. The string is shown in the dialog body. */
  reason: string | null;
  setReason: (reason: string | null) => void;
}

export const useNavGuardStore = create<NavGuardState>((set) => ({
  reason: null,
  setReason: (reason) => set({ reason }),
}));
